import { render, staticRenderFns } from "./residentes.vue?vue&type=template&id=44a0dc3f&scoped=true"
import script from "./residentes.vue?vue&type=script&lang=js"
export * from "./residentes.vue?vue&type=script&lang=js"
import style0 from "./residentes.vue?vue&type=style&index=0&id=44a0dc3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0dc3f",
  null
  
)

export default component.exports